import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'

// FontAwesome - global icon library
import '@fortawesome/fontawesome-free/css/all.min.css'

// Page loading styles
import '@/assets/css/page-loading.css'

// CSS is loaded from public/index.html (TECHZO theme)
// No need to import Bootstrap or main.css here

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)
app.mount('#app')
